export { default as Typography, type TypographyProps } from './Typography'
